import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import dayjs, {formatLocaleDate} from '@/dayjs'
import {ProjectExtended} from '@/features/projects/types'
import {Trans} from '@/translations/i18n'
import {Text} from '@/components/ui/text/Text'
import {ProjectDetailsHeaderEarlyClosingMotivation} from '../project-details-header-early-closing-motivation/ProjectDetailsHeaderEarlyClosingMotivation'

export const ProjectDetailsHeaderSubTitle = ({project}: {project: ProjectExtended}) => {
    return (
        <Flexbox gap={4}>
            <Text>
                {project.startDate ? (
                    <Trans
                        i18nKey="projects:start_date_value"
                        values={{
                            date: formatLocaleDate(project.startDate, 'DD/MM/YYYY')
                        }}
                        components={{b: <Text render="span" weight="500" palette="neutral" shade="950" />}}
                    />
                ) : (
                    '-'
                )}
            </Text>
            {project.expirationDate && (
                <Text>
                    <Trans
                        i18nKey="projects:end_date_value"
                        values={{
                            date: formatLocaleDate(project.expirationDate, 'DD/MM/YYYY')
                        }}
                        components={{b: <Text render="span" weight="500" palette="neutral" shade="950" />}}
                    />
                </Text>
            )}
            {project.endDate && dayjs(project.endDate).isBefore(dayjs(project.expirationDate)) && (
                <Text>
                    <Trans
                        i18nKey="projects:closed_date_value"
                        values={{
                            date: formatLocaleDate(project.endDate, 'DD/MM/YYYY')
                        }}
                        components={{b: <Text render="span" weight="500" palette="neutral" shade="950" />}}
                    />
                </Text>
            )}

            {project.expirationDate &&
                !project.conclusionReason &&
                dayjs(project.expirationDate).endOf('day').isBefore(dayjs()) &&
                (!project.endDate || dayjs(project.endDate).isSame(dayjs(project.expirationDate))) && (
                    <Text>
                        <Trans
                            i18nKey="projects:regular_closing_date"
                            values={{
                                date: formatLocaleDate(project.expirationDate, 'DD/MM/YYYY')
                            }}
                            components={{b: <Text render="span" weight="500" palette="neutral" shade="950" />}}
                        />
                    </Text>
                )}

            <ProjectDetailsHeaderEarlyClosingMotivation project={project} />
        </Flexbox>
    )
}
